import { GridColDef, GridRenderCellParams } from "esseal-data-table";
import { Autocomplete, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import { titleize } from "inflection";
import TimeAutocomplete from "@/components/TimeAutocomplete";
import { Issue, IssueTypeEnum } from "@/graphql/generated/graphql";

const diaryEntryColumns = (handleUpdate: (value: string, field: "startTime" | "endTime" | "issueType" | "description", id: string, description?: { text: string, categoryIds: string[] }) => void): GridColDef<Issue>[] => [
  {
    field: "startTime",
    headerName: "Start",
    width: 100,
    renderCell: ({ row }: GridRenderCellParams<Issue>) => {
      return (
        <TimeAutocomplete
          key={`issue-table-${row.id}-starttime-${row.startTime}`}
          time={row.startTime ? dayjs(row.startTime).format("HH:mm") : ''}
          onTimeChange={(newTime) => handleUpdate(newTime, "startTime", row.id)}
          sx={{ p: 0, m: 0, width: '100%' }}
        />
      );
    },
  },
  {
    field: "endTime",
    headerName: "End",
    width: 100,
    renderCell: ({ row }: GridRenderCellParams<Issue>) => {
      return (
        <TimeAutocomplete
          key={`issue-table-${row.id}-endtime-${row.endTime}`}
          time={row.endTime ? dayjs(row.endTime).format("HH:mm") : ''}
          onTimeChange={(newTime) => handleUpdate(newTime, "endTime", row.id)}
          sx={{ p: 0, m: 0, width: '100%' }}
        />
      );
    },
  },
  {
    field: "issueType",
    headerName: "Type",
    width: 200,
    renderCell: ({ row }: GridRenderCellParams<Issue>) => {
      return (
        <Autocomplete
          disableClearable
          options={Object.keys(IssueTypeEnum).map(key => IssueTypeEnum[key as keyof typeof IssueTypeEnum])}
          getOptionLabel={(option) => titleize(option)}
          value={row.issueType}
          size="small"
          sx={{ p: 1, m: 0, width: '100%', height: '20px', border: '1px solid grey', borderRadius: '6px' }}
          renderInput={(autocompleteParams) => <TextField {...autocompleteParams} variant="standard" sx={{ p: 0, m: 0 }} />}
          onChange={(_, value) => handleUpdate(value, "issueType", row.id)}
        />
      );
    }
  },
  {
    field: "description",
    headerName: "Details",
    width: 600,
    renderCell: ({ row }: GridRenderCellParams<Issue>) => {
      return (
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{ __html: row.description }}
        />
      )
    }
  }
];

export default diaryEntryColumns;
